import React, { useState, useContext } from 'react';

import PropTypes from 'prop-types';

import { Tabs, Tab, Typography, Box, IconButton, MenuItem, Menu, CircularProgress, Avatar } from '@mui/material';
import * as Icons from '@mui/icons-material';

import { FirebaseContext } from '../../Services/firebase'

import AddCustomer from '../../Components/addCustomer/AddCustomer';
import CustomerList from '../../Components/customerList/CustomerList';
import DocumentCreator from '../../Components/menuDocument/DocumentCreator'
import DocumentViewer from '../../Components/menuDocument/DocumentViewer';
import CustomerChoice from '../../Components/customerChoice/CustomerChoice';
import RecapWeek from '../../Components/recapWeek/RecapWeek';
import RecapChoices from '../../Components/recapChoices/RecapChoices';
import ChangeCustomerChoice from '../../Components/customerChoice/ChangeCustomerChoice';
import WeekChoices from '../../Components/weekChoices/WeekChoices'
import InvoicesWeek from '../../Components/invoicesWeek/InvoicesWeek'
import BreadCommand from '../../Components/breadCommand/BreadCommand'
import Taxation from '../../Components/taxation/taxation';

//import RecapDelivery from '../RecapDelivery/RecapDelivery';

import TopBar from '../topBar/TopBar';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index ? (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      ): null}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function SideBar(props) {

  const [mainTabValue, setMainTabValue] = useState(0);
  const [subTabValues, setSubTabValues] = useState([0, 0, 0, 0, 0, 0]);
  const [anchorEl, setAnchorEl] = useState(null);
  const firebase = useContext(FirebaseContext)


  const handleMainTabChange = (event, newValue) => {
    setMainTabValue(newValue);
  };

  const handleSubTabChange = (mainIndex, event, newValue) => {
    setSubTabValues((prevSubTabValues) => {
      const newSubTabValues = [...prevSubTabValues];
      newSubTabValues[mainIndex] = newValue;
      return newSubTabValues;
    });
  };

  const tabStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 2,
    flexDirection: 'row',
    height: "20px",
  };

  const logout = e => {
    firebase.logoutUser()
  }

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex', height: '90vh'}}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ padding: 2, display: 'flex', justifyContent: 'center' }}>
          <img src="/logo.png" alt="Logo" style={{ width: '100px' }} />
        </Box>
        <Tabs value={mainTabValue} onChange={handleMainTabChange} orientation="vertical">
          <Tab icon={<Icons.PersonOutline/>} aria-label="Clients"/>
          <Tab icon={<Icons.MenuBookOutlined/>} aria-label="Menu" />
          <Tab icon={<Icons.SoupKitchenOutlined/>} aria-label="Cuisine" />
          <Tab icon={<Icons.BreakfastDiningOutlined/>} aria-label="Pain" />
          <Tab icon={<Icons.DescriptionOutlined/>} aria-label="Documents" />
        </Tabs>
        <Box style={{ display: "flex", justifyContent: "center", flexDirection: "row"}}>
        { props.UserSession === null ? <CircularProgress color="success"/> :
              <div style={{position: 'absolute', bottom: 0}}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleMenu}
                  color="inherit"
                >
                    <Avatar>{props.Prenom.charAt(0).toUpperCase()}{props.Nom.charAt(0).toUpperCase()}</Avatar>
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem onClick={logout}>Se déconnecter</MenuItem>
                </Menu>
              </div>
            }
        </Box>
      </Box>
      <Box>
        {mainTabValue === 0 && (
          <>
            <h3 style={{position: 'absolute', top: 2, marginLeft: 15, fontFamily: 'Montserrat'}}>Clients</h3>
            <Box sx={{ display: 'flex', paddingTop: 13, backgroundColor: '#eee', height: '100%'}}>
              <Tabs
                value={subTabValues[0]}
                onChange={(e, newVal) => handleSubTabChange(0, e, newVal)}
                orientation="vertical">
                <Tab icon={<Icons.ContactPhoneOutlined/>} label="Infos client" {...a11yProps(0)} sx={tabStyle}/>
                <Tab icon={<Icons.GroupAddOutlined/>} label="Ajouter un client" {...a11yProps(1)} sx={tabStyle}/>
                <Tab icon={<Icons.InventoryOutlined/>} label="Choix clients" {...a11yProps(4)} sx={tabStyle}/>
                <Tab icon={<Icons.EditOutlined/>} label="Modifier choix clients" {...a11yProps(5)} sx={tabStyle}/>
                <Tab icon={<Icons.PictureAsPdfOutlined/>} label="Commandes client pdf" {...a11yProps(7)} sx={tabStyle}/>
              </Tabs>
            </Box>
          </>
        )}
        {mainTabValue === 1 && (
          <>
            <h3 style={{position: 'absolute', top: 2, marginLeft: 15, fontFamily: 'Montserrat'}}>Menu</h3>
            <Box sx={{ display: 'flex', paddingTop: 19, backgroundColor: '#eee', height: '100%' }}>
              <Tabs
                value={subTabValues[1]}
                onChange={(e, newVal) => handleSubTabChange(1, e, newVal)}
                orientation="vertical">
                <Tab icon={<Icons.CreateNewFolderOutlined/>} label="Nouveau menu" {...a11yProps(2)} sx={tabStyle}/>
                <Tab icon={<Icons.PictureAsPdfOutlined/>} label="Menus pdf" {...a11yProps(3)} sx={tabStyle}/>
                <Tab icon={<Icons.PersonOutlineOutlined/>} label="Menu client" {...a11yProps(9)} sx={tabStyle}/>
              </Tabs>
            </Box>
          </>

        )}
        {mainTabValue === 2 && (
          <>
            <h3 style={{position: 'absolute', top: 2, marginLeft: 15, fontFamily: 'Montserrat'}}>Cuisine</h3>
            <Box sx={{ display: 'flex', paddingTop: 25, backgroundColor: '#eee', height: '100%' }}>
              <Tabs
                value={subTabValues[2]}
                onChange={(e, newVal) => handleSubTabChange(2, e, newVal)}
                orientation="vertical">
                <Tab icon={<Icons.FoodBankOutlined/>} label="Commande cuisine" {...a11yProps(6)} sx={tabStyle}/>
              </Tabs>
            </Box>
          </>

        )}
        {mainTabValue === 3 && (
          <>
            <h3 style={{position: 'absolute', top: 2, marginLeft: 15, fontFamily: 'Montserrat'}}>Pain</h3>
            <Box sx={{ display: 'flex', paddingTop: 31, backgroundColor: '#eee', height: '100%' }}>
              <Tabs
                value={subTabValues[3]}
                onChange={(e, newVal) => handleSubTabChange(3, e, newVal)}
                orientation="vertical">
                <Tab icon={<Icons.BreakfastDiningOutlined/>} label="Commande pain" {...a11yProps(11)} sx={tabStyle}/>
              </Tabs>
            </Box>
          </>

        )}
        {mainTabValue === 4 && (
          <>
            <h3 style={{position: 'absolute', top: 2, marginLeft: 15, fontFamily: 'Montserrat'}}>Documents</h3>
            <Box sx={{ display: 'flex', paddingTop: 37, backgroundColor: '#eee', height: '100%' }}>
              <Tabs
                value={subTabValues[4]}
                onChange={(e, newVal) => handleSubTabChange(4, e, newVal)}
                orientation="vertical">
                <Tab icon={<Icons.SavingsOutlined/>} label="Facture" {...a11yProps(11)} sx={tabStyle}/>
                <Tab icon={<Icons.RequestQuoteOutlined/>} label="Attestation fiscale" {...a11yProps(11)} sx={tabStyle}/> 
              </Tabs>
            </Box>
          </>
        )}
      </Box>
      {mainTabValue === 0 && (
        <>
          {[
            {
              title: "Informations Client",
              component: <CustomerList UserSession={props.UserSession} />,
            },
            {
              title: "Ajouter un Client",
              component: <AddCustomer UserSession={props.UserSession} />,
            },
            {
              title: "Choix Client",
              component: <CustomerChoice UserSession={props.UserSession} />,
            },
            {
              title: "Modifier Choix Client",
              component: <ChangeCustomerChoice UserSession={props.UserSession} />,
            },
            {
              title: "Commandes Client PDF",
              component: <RecapChoices UserSession={props.UserSession} />,
            },
          ].map((tab, index) => (
            <TabPanel key={index} value={subTabValues[0]} index={index} style={{ flexGrow: 1 }}>
              <TopBar title={tab.title} />
              {tab.component}
            </TabPanel>
          ))}
        </>
      )}
      {mainTabValue === 1 &&
        [
          {
            index: 0,
            title: 'Nouveau Menu',
            content: <DocumentCreator UserSession={props.UserSession} />,
          },
          {
            index: 1,
            title: 'Menu PDF',
            content: <DocumentViewer UserSession={props.UserSession} />,
          },
          {
            index: 2,
            title: 'Menu Client',
            content: <WeekChoices UserSession={props.UserSession} />,
          },
        ].map(({ index, title, content }) => (
          <TabPanel key={index} value={subTabValues[1]} index={index} style={{ flexGrow: 1 }}>
            <TopBar title={title} />
            {content}
          </TabPanel>
        ))
      }
      {mainTabValue === 2 && 
          <TabPanel value={subTabValues[2]} index={0} style={{flexGrow: 1}}>
            <TopBar title="Commande Cuisine"/>
            <RecapWeek UserSession={props.UserSession}/>
          </TabPanel>
      }
      {mainTabValue === 3 &&
          <TabPanel value={subTabValues[3]} index={0} style={{flexGrow: 1}}>
            <TopBar title="Commande Pain"/>
            <BreadCommand UserSession={props.UserSession}/>
          </TabPanel>
      }
      {mainTabValue === 4 &&
          <TabPanel value={subTabValues[4]} index={0} style={{flexGrow: 1}}>
            <TopBar title="Facture"/>
            <InvoicesWeek UserSession={props.UserSession}/>
          </TabPanel>
      }
      {mainTabValue === 4 && 
          <TabPanel value={subTabValues[4]} index={1} style={{flexGrow: 1}}>
            <TopBar title="Attestation Fiscale"/>
            <Taxation UserSession={props.UserSession}/>
          </TabPanel>
      }
      {/*<TabPanel value={value} index={8}>
        <RecapDelivery UserSession={props.UserSession}/>
      </TabPanel>*/}
      <p style={{ position: 'absolute', right: 25, top: 80, fontSize: 10, color: 'grey'}}>v{process.env.REACT_APP_VERSION}</p>
    </Box>
  );
}